import React from 'react';
import {z} from 'zod';

import {AccountCircleOutlined} from '@mui/icons-material';

import {Text,TextPropsSchema} from './Text';
import TextSidebarPanel from './TextSidebarPanel';

export type TextProps = z.infer<typeof TextPropsSchema>;

export default {
    label: 'Text',
    icon: <AccountCircleOutlined />,
    type: 'Text',
    defaultData: {
        props: { text: 'Text Content' },
        style: {
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
            fontWeight: 'normal',
            fontSize: 16,
        },
    },
    SidebarPanel: TextSidebarPanel,
    Component: Text,
    schema: TextPropsSchema,
};